// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ELjcq","modal-content":"Modal_modal-content__H7IM4","btn":"Modal_btn__ZN3G-","overlay":"Modal_overlay__khgCm"};